import React from 'react';
import ReactToolTip from 'react-tooltip';
import { connect } from 'react-redux';

import Console from '../../../lib/debug';

const Tooltips = props => {
    Console.render('Tooltips');
    let content = props.content;
    if (!content || !content.content) return <div />;

    return (
        <ReactToolTip
            id="topside"
            class={content.className}
            place={content.place}
            dataHtml={content.dataHtml}
            type={content.type}
            getContent={[() => content.content, 200]}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps,
        content: state.calendar.uiTree.tooltipContent
    };
};

export default connect(mapStateToProps)(Tooltips);



// WEBPACK FOOTER //
// ./src/view/calendar/components/Tooltips.jsx